<template>
  <b-card no-body v-if="false">
    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle="'sms-notifications-unavailable-banner-collapse'">
      Important Notice: SMS Notifications Unavailable 📵 <small>(Click for more details)</small>
    </b-card-header>
    <b-collapse id="sms-notifications-unavailable-banner-collapse" accordion="my-accordion" role="tabpanel">
      <b-card-body class="description">
        <p>Stay Informed via Email 📧</p>
        <p>
          Please note that SMS notifications are temporarily unavailable. 
          Keep an eye on your inbox for important updates and notifications via email. 
          We apologize for any inconvenience and appreciate your understanding.
        </p>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
div.card {
  @include border-radius($border-radius);
  @include pop-yellow-gradient;

  color: $black;
  padding-left: 5px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom:15px;
  
  .card-header {
    cursor: pointer;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.00);
    border-bottom: none
  }
}
</style>